<template>
    <section id="ForgotPassword">
        <div class="card wmin-sm-400">
            <div v-if="!alreadychangpass" class="card-body">
                <div class="text-center mb-3">
                    <img alt :src="$storeIndex.getImageGobalAssets('authorization/logo-goship-gosell')" class='logo-goship-gosell' />
                </div>
                <div v-if="message" class="form-group">
                    <div class="alert alert-danger">
                        <i class="fa fa-info-circle"></i> {{ $t(message) }}
                    </div>
                </div>
                <div class="text-center mb-3">
                    <h3>{{$t('Forgot Password')}}</h3>
                    <p class="text-muted">{{$t('Type in the email for which you need a new password.')}}</p>
                </div>
                <div class="form-group form-group-feedback form-group-feedback-left" v-bind:class="{'form-group-error': $v.form.email.$error}">
                    <input type="text" class="form-control" :placeholder="$t('Your Email')" v-model.trim.lazy="$v.form.email.$model" />
                    <div class="form-control-feedback">
                        <i class="fa-envelope far text-muted"></i>
                    </div>
                    <div v-if="!$v.form.email.required" class="validation-invalid-label">{{$t('Please enter email.')}}</div>
                    <div v-if="!$v.form.email.email" class="validation-invalid-label">{{$t('Email invalid')}}</div>
                </div>

                <div class="form-group">
                    <ladda text="Confirm" :disabled="$v.validationGroup.$invalid" :btnClass="'btn btn-primary btn-block'" :loading="loading" @click="goChangePassword()"></ladda>
                </div>



                <div class="form-group">
                    <router-link  :to="{ name: 'login' }">
                        <button type="button" class="btn btn-light btn-block">{{$t('Back')}}</button>
                    </router-link>
                </div>
                <div class="form-group mb-0">
                    <div class="btn-group-justified">
                        <ul class="m-auto navbar-nav" style="width: 125px;">
                            <li class="nav-item dropdown language-switch">
                                <a class="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                                    <img :src="$storeIndex.getImageSrc('lang/' + lang)" class="img-flag mr-2" alt=""> {{$t(title)}}
                                </a>
                                <div class="dropdown-menu">
                                    <a v-for="(value, key) in localList" :name="key" :key="`lang-${key}`" @click="selectLang(key)" href="javascript:void(0);" class="dropdown-item english">
                                        <img :src="$storeIndex.getImageSrc('lang/' + key)" class="img-flag" alt=""> {{ $t(value) }}
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="alreadychangpass" class="card-body">
                <div class="text-center mb-3">
                    <img alt :src="$storeIndex.getImageGobalAssets('authorization/logo-goship-gosell')" class='logo-goship-gosell' />
                </div>
                <div class="text-center mb-3">
                    <h3>{{$t('Confirm change password')}}</h3>
                    <div class="text-muted">{{$t('Please check your email to change your password.')}}</div>
                    <div class="text-muted">{{$t('If you do not receive an email, press resend again')}}</div>
                </div>
                <div class="text-center mb-3">
                    <ladda text="Resend again" :disabled="resendDelay === 0 ? false : true" :btnClass="'btn btn-primary btn-block'" :loading="loading" @click="goChangePassword()">
                        <template v-slot:append-text>
                            <span v-if="resendDelay > 0">
                                ({{ resendDelay }})
                            </span>
                        </template>
                    </ladda>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
    div.validation-invalid-label { display: none !important; }
    div.form-group-error>div.validation-invalid-label { display: block !important; }
</style>

<script>
import CentralApi from '@/services/endpoint/central.service'
import { email,required } from "vuelidate/lib/validators";
import { helpers } from 'vuelidate/lib/validators'
import Ladda from '@/plugins/Ladda.vue'
import {
    localSave,
    localRead
} from "@/store/lang";

export default {
    components: {
        Ladda
    },
    data() {
        return {
            loading: false,
            message: '',
            alreadychangpass: false,
            lang: localRead("local"),
            localList: {
                th: "Thai",
                en: "English",
            },
            form: {
                email: ''
            },
            resendDelay: 60,
        };
    },
    computed: {
        title() {
            return this.localList[this.lang];
        },
    },
    validationConfig: {
        $lazy: true
    },
    validations: {
        form: {
            email :{
                required,
                email,
            }
        },
        validationGroup: ['form.email']
    },
    methods: {

        async goChangePassword(){
            let allow = await CentralApi.Auth.iswhitelistEmail(this.$v.form.email.$model);
            if(!allow.data.whitelist){
                let notAllowed = await CentralApi.Auth.isblacklistEmail(this.$v.form.email.$model);
                if(notAllowed.data.blacklist){
                    this.$toastr.Add({
                        type: "warning",
                        title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                        msg: this.$t("Email cannot be sent to")+" "+
                             this.$v.form.email.$model+" "+
                             this.$t("because this recipient is in blacklist.")+" "+
                             this.$t("If you feel this is a mistake, contact your admin."),
                        clickClose: true,
                        timeout: 5000,
                        position: "toast-top-right"
                    });
                    return false;
                }
            }
            this.loading = true;
            let params = {
                email: this.$v.form.email.$model
            };
            try {
                const res = await CentralApi.Auth.forgotPassword(params);
                if (!res.data.forgotpassword) {
                    this.message = 'This email does not exist in the system.';
                } else {
                    this.alreadychangpass = true;
                    this.setDelay(); // start delay
                    this.resendDelay = 60; // reset delay after sending email
                }
                this.loading = false;
                return true;
            } catch (error) {
                this.loading = false;
                let message = error.response.data.message;
                if(message == "This email is blacklisted.") {
                    message = this.$t("Email cannot be sent to")+" "+
                            this.$v.form.email.$model+" "+
                            this.$t("because this recipient is in blacklist.")+" "+
                            this.$t("If you feel this is a mistake, contact your admin.");
                }
                this.$toastr.Add({
                    type: "warning",
                    title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                    msg: message,
                    clickClose: true,
                    timeout: 5000,
                    position: "toast-top-right"
                });
                return false;
            }
        },
        selectLang(lang) {
            localSave("local", lang);
            location.reload();
        },
        setDelay: function () {
            let delaySendPassword = setInterval(() => {
                this.resendDelay -= 1;
                if (this.resendDelay === 0) {
                    clearInterval(delaySendPassword);
                }
            }, 1000);
        }
    },

};
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/ForgotPassword.vue